import Head from "next/head";
import styled from "styled-components";
import Button from "components/Button";
import AdSense, { hasAdSense } from "components/AdSense";

const PageHero = styled.section`
  position: relative;
  min-height: 70vh;
  display: flex;
  align-items: center;
  text-align: center;
  background-color: #000;

  &::after {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    display: block;
    width: 100%;
    height: 100%;
    background-color: rgba(139, 139, 139, 0.77);
  }
`;

const ImageBg = styled.img`
  display: block;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  flex: 1 1 100%;
  width: 100%;
  max-width: 120rem;
  margin: 0 auto;
  color: #fff;
  padding: 13rem 1.5rem;
`;

const Intro = styled.p`
  margin-bottom: 2rem;
  font-size: 1.8rem;

  @media (min-width: 640px) {
    font-size: 2rem;
  }

  @media (min-width: 1200px) {
    font-size: 2.4rem;
  }
`;

const Title = styled.h1`
  margin-bottom: 4rem;
  font-size: 3.5rem;

  @media (min-width: 480px) {
    font-size: 3.6rem;
  }

  @media (min-width: 640px) {
    font-size: 6vw;
  }

  @media (min-width: 1200px) {
    font-size: 7rem;
    margin-bottom: 6rem;
  }
`;

const AdSenseContainer = styled.div`
  position: absolute;
  z-index: 2;
  bottom: 2rem;
  left: 0;
  display: block;
  width: 100%;
  height: auto;
`;

const Hero = (props) => {
  const showAdSense = hasAdSense({
    location: "landing_page",
    user: props.user,
    ...props.adsense,
  });

  return (
    <>
      <Head>
        <link rel="preload" href={props.image} as="image" />
      </Head>

      <PageHero>
        <ImageBg src={props.image} alt={props.name} />

        <Content>
          {props.introduction && <Intro>{props.introduction}</Intro>}
          <Title>{props.name}</Title>

          <Button
            href="/quiz/[slug]/questions"
            as={`/quiz/${props.slug}/questions`}
          >
            {props.buttonText}
          </Button>
        </Content>

        {showAdSense && (
          <AdSenseContainer>
            <AdSense
              location="landing_page"
              type="banner"
              {...props.adsense}
              user={props.user}
            />
          </AdSenseContainer>
        )}
      </PageHero>
    </>
  );
};

export default Hero;
